import React from 'react';

import PropTypes from 'prop-types';

import { useConfigValue } from '~/shared/utils/config';
import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';

import { LAYOUT_TYPE } from '../../../constants';
import {
  isCioColorFacet,
  isCustomBraFilter,
  isImageSwatchFacet,
  isProductsV2ColorFacet,
} from '../../../utils/filters';

import FilterOptionsColor from './FilterOptionsColor';
import FilterOptionsColorWheel from './FilterOptionsColorWheel';
import FilterOptionsCustomBra from './FilterOptionsCustomBra';
import FilterOptionsDefaultBtn from './FilterOptionsDefaultBtn';
import FilterOptionsDefaultCheckbox from './FilterOptionsDefaultCheckbox';
import FilterOptionsWithImage from './FilterOptionsWithImage';

const FilterOptionsRenderer = ({
  facetName,
  options,
  onClick,
  isSelected,
  isDisabled,
  layoutType = LAYOUT_TYPE.FILTER_PANEL,
}) => {
  const { enabled: isColorWheelGridFilterEnabled } = useHasFeature(
    featureNames.COLOR_WHEEL_GRID_FILTER
  );
  const imageSwatchFilters = useConfigValue('public.imageSwatchFilters');

  const commonProps = {
    facetName,
    options,
    onClick,
    isSelected,
    isDisabled,
    layoutType,
  };

  const isFilterWithImage = isImageSwatchFacet({
    facetName,
    imageSwatchFilters,
  });

  if (isFilterWithImage) {
    return <FilterOptionsWithImage {...commonProps} />;
  }

  if (isCustomBraFilter(facetName)) {
    return <FilterOptionsCustomBra {...commonProps} />;
  }

  if (isCioColorFacet(facetName) || isProductsV2ColorFacet(facetName)) {
    return isColorWheelGridFilterEnabled ? (
      <FilterOptionsColorWheel {...commonProps} />
    ) : (
      <FilterOptionsColor {...commonProps} />
    );
  }

  return layoutType === LAYOUT_TYPE.FILTER_PANEL ? (
    <FilterOptionsDefaultCheckbox {...commonProps} />
  ) : (
    <FilterOptionsDefaultBtn {...commonProps} />
  );
};

FilterOptionsRenderer.propTypes = {
  facetName: PropTypes.string.isRequired,
  isDisabled: PropTypes.func,
  isSelected: PropTypes.func.isRequired,
  layoutType: PropTypes.oneOf(Object.values(LAYOUT_TYPE)),
  onClick: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      display_name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default FilterOptionsRenderer;
